import React from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { staffCalendarAwaitingUrl, staffTicketUrl } from '../../utils/appearanceAlertUrls';

/**
 * Old appearance-alert paths the cron used to write. They are not real staff routes;
 * send them to the live ticket / calendar pages and keep courtEvent / awaiting on the query.
 */
export const LegacyAppearanceCaseRedirect: React.FC = () => {
  const { ticketGuid } = useParams<{ ticketGuid: string }>();
  const [params] = useSearchParams();
  if (!ticketGuid) {
    return <Navigate to="/" replace />;
  }
  return <Navigate to={staffTicketUrl(ticketGuid, params.get('courtEvent'))} replace />;
};

export const LegacyAppearanceCalendarRedirect: React.FC = () => {
  const [params] = useSearchParams();
  if (params.get('appearanceOutcome') === 'awaiting') {
    return <Navigate to={staffCalendarAwaitingUrl()} replace />;
  }
  const query = params.toString();
  return <Navigate to={query ? `/calendar?${query}` : '/calendar'} replace />;
};
